"use client";

import { useEffect, useState } from "react";
import { LuTriangleAlert } from "react-icons/lu";
import { useTranslations } from "next-intl";

interface NoReferenceWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NoReferenceWarningModal = ({ isOpen, onClose }: NoReferenceWarningModalProps) => {
  const [mounted, setMounted] = useState(false);
  const t = useTranslations("jobberProfile.forms.stepThree.noReferenceWarning");

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center justify-center mb-4">
            <div className="bg-yellow-100 rounded-full p-3">
              <LuTriangleAlert size={24} className="text-yellow-600" />
            </div>
          </div>
          
          <h3 className="text-lg font-semibold text-gray-900 text-center mb-3">
            {t("title")}
          </h3>
          
          <p className="text-gray-600 text-center mb-6 leading-relaxed">
            {t("message")}
          </p>
          
          <div className="flex justify-center">
            <button
              onClick={onClose}
              className="tracking-wide transition-colors duration-200 transform focus:outline-none focus:ring focus:ring-opacity-50 rounded-full px-7 py-2 bg-brand-500 hover:bg-brand-400 focus:bg-brand-400 focus:ring-brand-300 text-white cursor-pointer"
            >
              {t("okButton")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
